import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		name: 'login',
		meta: { title: '登录' },
		component: () => import('../views/login.vue')
	},
	{
		path: '/homeFxs',
		name: 'homeFxs',
		meta: { title: '首页' },
		component: () => import('../views/homeFxs.vue'),
		children:[
			{
				path: '/',
				redirect: "/fxWorke"
			},
			{
				path: '/fxWorke',
				name: 'fxWorke',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/fxWorke.vue')
			},
			{
				path: '/allMsg',
				name: 'allMsg',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/workbench/allMsg.vue')
			},
			
			{
				path: '/fxSet',
				name: 'fxSet',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/xtSet/fxSet.vue')
			},
			{
				path: '/personSet',
				name: 'personSet',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/xtSet/personSet.vue')
			},
			{
				path: '/ejFxs',
				name: 'ejFxs',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/ejFxs/ejFxs.vue')
			},
			{
				path: '/FxsScenicMange',
				name: 'FxsScenicMange',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/scenicMange/FxsScenicMange.vue')
			},
			{
				path: '/orderMang',
				name: 'orderMang',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/financeMang/orderMang.vue')
			},
			{
				path: '/oring',
				name: 'oring',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/financeMang/oring.vue')
			},
			{
				path: '/sellOrder',
				name: 'sellOrder',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/financeMang/sellOrder.vue')
			},
			{
				path: '/sellSta',
				name: 'sellSta',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/financeMang/sellSta.vue')
			},
			{
				path: '/reserveOrder',
				name: 'reserveOrder',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/financeMang/reserveOrder.vue')
			},
			{
				path: '/invoiceExamine',
				name: 'invoiceExamine',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/financeMang/invoiceExamine.vue')
			},
			{
				path: '/PayList',
				name: 'PayList',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/financeMang/PayList.vue')
			},
			{
				path: '/invoiceSet',
				name: 'invoiceSet',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/financeMang/invoiceSet.vue')
			},
			{
				path: '/costInfo',
				name: 'costInfo',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/financeMang/costInfo.vue')
			},
			{
				path: '/proList',
				name: 'proList',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/product/proList.vue')
			},
			{
				path: '/advanceList',
				name: 'advanceList',
				meta: { title: '一级分销商' },
				component: () => import('../components/distributor/product/advanceList.vue')
			},
		]
	},
	{
		path: '/home',
		name: 'home',
		meta: { title: '景区管理后台' },
		component: () => import('../views/Home.vue'),
		children:[
			{
				path: '/',
				redirect: "/worke"
			},
			{
				path: '/worke',
				name: 'worke',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/worke.vue')
			},
			{
				path: '/xcx',
				name: 'xcx',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/xcx.vue')
			},
			{
				path: '/infos',
				name: 'infos',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/yin/infos.vue')
			},
			{
				path: '/lost',
				name: 'lost',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/yin/lost.vue')
			},
			{
				path: '/yinProduct',
				name: 'yinProduct',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/yin/productList.vue')
			},
			{
				path: '/yinorder',
				name: 'yinorder',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/yin/order.vue')
			},
			{
				path: '/leave',
				name: 'leave',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/yin/leave.vue')
			},
			{
				path: '/productList',
				name: 'productList',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/pro/productList.vue')
			},
			{
				path: '/productTypeList',
				name: 'productTypeList',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/pro/productTypeList.vue')
			},
			{
				path: '/myvue',
				name: 'myvue',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/pro/myApi.vue')
			},
			{
				path: '/recycle',
				name: 'recycle',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/pro/recycle.vue')
			},
			{
				path: '/ticket',
				name: 'ticket',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/pro/ticket.vue')
			},
			{
				path: '/reservePro',
				name: 'reservePro',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/pro/reservePro.vue')
			},
			{
				path: '/allMsgs',
				name: 'allMsgs',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/workbench/allMsg.vue')
			},
			{
				path: '/reServeOrderSc',
				name: 'reServeOrderSc',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/pro/reServeOrder.vue')
			},
			{
				path: '/reTicket',
				name: 'reTicket',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/pro/reTicket.vue')
			},
			{
				path: '/scenicSet',
				name: 'scenicSet',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/secenSet/scenicSet.vue')
			},
			{
				path: '/rightMan',
				name: 'rightMan',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/secenSet/rightMan.vue')
			},
			{
				path: '/cooperation',
				name: 'cooperation',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/secenSet/cooperation.vue')
			},
			{
				path: '/providerSet',
				name: 'providerSet',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/secenSet/providerSet.vue')
			},
			{
				path: '/order',
				name: 'order',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/order.vue')
			},
			{
				path: '/miniOrder',
				name: 'miniOrder',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/miniOrder.vue')
			},
			{
				path: '/revoke',
				name: 'revoke',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/revoke.vue')
			},
			{
				path: '/ording',
				name: 'ording',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/oring.vue')
			},
			{
				path: '/dylist',
				name: 'dylist',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/dylist.vue')
			},
			{
				path: '/date',
				name: 'date',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/date.vue')
			},
			{
				path: '/directSta',
				name: 'directSta',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/directSta.vue')
			},
			{
				path: '/distribution',
				name: 'distribution',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/distribution.vue')
			},
			{
				path: '/comboStatistics',
				name: 'comboStatistics',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/comboStatistics.vue')
			},
			{
				
				path: '/report',
				name: 'report',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/report/index.vue')
			},
			{
				path: '/noteSta',
				name: 'noteSta',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/noteSta.vue')
			},
			{
				path: '/reserveSta',
				name: 'reserveSta',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/reserveSta.vue')
			},
			{
				path: '/operAnalysis',
				name: 'operAnalysis',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/operAnalysis.vue')
			},
			{
				path: '/jointCard',
				name: 'jointCard',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/jointCard.vue')
			},
			{
				path: '/orderQuery',
				name: 'orderQuery',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/orderQuery.vue')
			},
			{
				path: '/PaymentList',
				name: 'PaymentList',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/PaymentList.vue')
			},
			{
				path: '/invoiceList',
				name: 'invoiceList',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/finance/invoiceList.vue')
			},
			{
				path: '/retail',
				name: 'retail',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/retail/retail.vue')
			},
			{
				path: '/wxContent',
				name: 'wxContent',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/wxMange/wxContent.vue')
			},
			{
				path: '/userList',
				name: 'userList',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/wxMange/userList.vue')
			},
			{
				path: '/albumMange',
				name: 'albumMange',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/wxMange/albumMange.vue')
			},
			{
				path: '/wShopping',
				name: 'wShopping',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/Market/wShopping.vue')
			},
			{
				path: '/wRestaurant',
				name: 'wRestaurant',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/Market/wRestaurant.vue')
			},
			{
				path: '/turntable',
				name: 'turntable',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/Market/turntable.vue')
			},
			{
				path: '/AllPeople',
				name: 'AllPeople',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/Market/AllPeople.vue')
			},
			{
				path: '/Mcatering',
				name: 'Mcatering',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/wechat/Mcatering.vue')
			},
			{
				path: '/wcMall',
				name: 'wcMall',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/wechat/wcMall.vue')
			},
			{
				path: '/cinema',
				name: 'cinema',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/wechat/cinema.vue')
			},
			{
				path: '/addcinema',
				name: 'addcinema',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/wechat/dialog/addcin.vue')
			},
			{
				path: '/addlist',
				name: 'addlist',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/wechat/dialog/addlist.vue')
			},
			{
				path: '/showdate',
				name: 'showdate',
				meta: { title: '景区管理后台' },
				component: () => import('../components/scenic/wechat/dialog/showdate.vue')
			},
		]
	},
	{
		path: '/superlogin',
		name: 'superlogin',
		meta: {
			title: '超管登录'
		},
		component: () => import('../views/superlogin.vue')
	},
	// {
	// 	path: '/scenicLogin',
	// 	name: 'scenicLogin',
	// 	meta: {
	// 		title: '景区客户端'
	// 	},
	// 	component: () => import('../views/scenicLogin.vue')
	// },
	{
		path: '/supehome',
		name: 'supehome',
		meta: {
			title: '金飞鹰后台管理系统'
		},
		component: () => import('../views/supehome.vue'),
		children: [{
				path: '/workebench',
				name: 'workebench',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/worke/workebench.vue')
			},
			{
				path: '/scenicMange',
				name: 'scenicMange',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/scenic/scenicMange.vue')
			},
			{
				path: '/scenicbalance',
				name: 'scenicbalance',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/scenic/scenicbalance.vue')
			},
			{
				path: '/smsTemplate',
				name: 'smsTemplate',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/scenic/smsTemplate.vue')
			},
			{
				path: '/smsrefund',
				name: 'smsrefund',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/scenic/refund.vue')
			},
			{
				path: '/oneFxs',
				name: 'oneFxs',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/fxsmanage/oneFxs.vue')
			},
			{
				path: '/twoFxs',
				name: 'twoFxs',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/fxsmanage/twoFxs.vue')
			},
			{
				path: '/fxsVerify',
				name: 'fxsVerify',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/fxsmanage/fxsVerify.vue')
			},
			{
				path: '/changeMm',
				name: 'changeMm',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/set/changeMm.vue')
			},
			{
				path: '/news',
				name: 'news',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/set/news.vue')
			},
			{
				path: '/customer',
				name: 'customer',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/set/customer.vue')
			},
			{
				path: '/partners',
				name: 'partners',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/set/partners.vue')
			},
			{
				path: '/billSet',
				name: 'billSet',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/set/billSet.vue')
			},
			{
				path: '/adminMange',
				name: 'adminMange',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/set/adminMange.vue')
			},
			{
				path: '/roleMange',
				name: 'roleMange',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/set/roleMange.vue')
			},
			{
				path: '/bossMange',
				name: 'bossMange',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/set/bossMange.vue')
			},
			{
				path: '/financeScenic',
				name: 'financeScenic',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/deposit/financeScenic.vue')
			},
			{
				path: '/financeFxsOne',
				name: 'financeFxsOne',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/deposit/financeFxsOne.vue')
			},
			{
				path: '/financeFxsTwo',
				name: 'financeFxsTwo',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/deposit/financeFxsTwo.vue')
			},


			{
				path: '/xwtSellSta',
				name: 'xwtSellSta',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/fxsOrder/xwtSellSta.vue')
			},
			{
				path: '/xwtTicketSta',
				name: 'xwtTicketSta',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/fxsOrder/xwtTicketSta.vue')
			},
			{
				path: '/fxsOneSellSta',
				name: 'fxsOneSellSta',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/fxsOrder/fxsOneSellSta.vue')
			},
			{
				path: '/fxsOneTicketSta',
				name: 'fxsOneTicketSta',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/fxsOrder/fxsOneTicketSta.vue')
			},
			{
				path: '/fxsTwoSellSta',
				name: 'fxsTwoSellSta',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/fxsOrder/fxsTwoSellSta.vue')
			},
			{
				path: '/fxsTwoTicketSta',
				name: 'fxsTwoTicketSta',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/fxsOrder/fxsTwoTicketSta.vue')
			},

			{
				path: '/scenicSellSta',
				name: 'scenicSellSta',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/scenicOrder/scenicSellSta.vue')
			},
			{
				path: '/scenicTicketSta',
				name: 'scenicTicketSta',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/scenicOrder/scenicTicketSta.vue')
			},
			{
				path: '/couponList',
				name: 'couponList',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/couponList.vue')
			},
			{
				path: '/noteDeposit',
				name: 'noteDeposit',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/finance/noteDeposit.vue')
			},
			{
				path: '/videoList',
				name: 'videoList',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/video/vedioList.vue')
			},
			{
				path: '/vedioSet',
				name: 'vedioSet',
				meta: {
					title: '金飞鹰后台管理系统'
				},
				component: () => import('../components/supertube/video/vedioSet.vue')
			},
		],
	},
	{
    path:'/secondlogin',
    name:'secondlogin',
    meta:{title:'二级分销商登录'},
    component: () => import("../views/secondlogin.vue"),
  },
	{
    path: "/dis",
    name: "secondHome",
    meta: { title: "二级分销商后台" },
    component: () => import("../views/secondHome.vue"),
    children: [
      {
        path: "/dis",
        name: "dis",
        meta: { title: "二级分销商后台" },
        component: () => import("../views/distributor.vue"),
      },
      {
        path: "/product",
        name: "product",
        meta: { title: "二级分销商后台" },
        component: () => import("../views/product.vue"),
      },
      {
        path: "/system",
        name: "system",
        meta: { title: "二级分销商后台" },
        component: () => import("../views/system.vue"),
      },
      {
        path: "/secondorder",
        name: "secondorder",
        meta: { title: "二级分销商后台" },
        component: () => import("../components/secondary/order.vue"),
      },
      {
        path: "/statistics",
        name: "statistics",
        meta: { title: "二级分销商后台" },
        component: () => import("../components/secondary/statistics.vue"),
      },
      {
        path: "/refund",
        name: "refund",
        meta: { title: "二级分销商后台" },
        component: () => import("../components/secondary/refund.vue"),
      },
      {
        path:'/limits',
        name: "limits",
        meta: { title: "二级分销商后台" },
        component: () => import("../components/secondary/limits.vue"),
      },
      {
        path:'/resetting',
        name: "resetting",
        meta: { title: "二级分销商后台" },
        component: () => import("../components/secondary/resetting.vue"),
      }
    ],
  },
	{
			path: "*",
			name: "404",
			meta: { title: "404" },
			component: () => import("@/views/404.vue"),
	}
]

const router = new VueRouter({
	mode: 'history',
	routes
})
// 导航全局前置守卫
router.beforeEach((to, from, next) => {
	document.title = to.meta.title
	if(to.path=='/wShopping'){
		router.push('/worke')
		window.open('http://jfymember.softykt.cn/index?id='+window.sessionStorage.getItem('ScenicId'), '_blank')
	}
	console.log(window.sessionStorage.getItem('Token'),111)
	
	if (to.path != "/login") {
		if(to.path != "/superlogin"){
			if(to.path !='/secondlogin'){
					next();
			}else{
				next();
			}
		}else{
			next();
		}
	}else{
		next();
	}
})

export default router
